import { render, staticRenderFns } from "./InputDocument.vue?vue&type=template&id=e4c6eb56&scoped=true"
import script from "./InputDocument.vue?vue&type=script&lang=js"
export * from "./InputDocument.vue?vue&type=script&lang=js"
import style0 from "./InputDocument.vue?vue&type=style&index=0&id=e4c6eb56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c6eb56",
  null
  
)

export default component.exports